import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { vendor as vendorApi } from '../../../api';
import { VendorDetailContext } from '../../../contexts';
import { useApi, useAuth } from '../../../hooks';
import { VendorInvoicingInformationSchema } from '../../../schemas/Vendor';
import { PermissionKey } from '../../../types';
import { EditCardSkeleton } from '../../Card';
import { InvoicingInformationForm } from './InvoicingInformationForm';

export const InvoicingInformationAdmin = () => {
  const { hasPermissions } = useAuth();
  const { t } = useTranslation();
  const { vendor, vendorId } = useContext(VendorDetailContext);
  const { data, isLoading, refresh } = useApi(vendorApi.getInvoicingInformation, null, vendorId);
  const { call } = useApi(vendorApi.updateInvoicingInformation, { successKey: 'common:success.save' });

  return (
    <EditCardSkeleton
      readOnly={!hasPermissions(PermissionKey.VendorEditFinancial)}
      entity={data}
      isLoading={isLoading}
      title={t('vendor:financials.sections.invoicingInformation')}
      disabled={vendor?.isArchived}
      schema={VendorInvoicingInformationSchema()}
      onSave={call}
      onConfirm={() => refresh()}
      showModifiedDate
    >
      <InvoicingInformationForm />
    </EditCardSkeleton>
  );
};
